import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Fetcha i riepiloghi feedback per una lista di articoli in un'unica chiamata.
 * Foundation: opera su qualsiasi Pack.
 *
 * Ritorna: { summaries, refresh, loading }
 *   summaries: { [articleId]: {helpful, not_helpful, total, my_verdict} }
 */
export function useGuideFeedbackSummaries(appKey, articleIds) {
  const [summaries, setSummaries] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (!appKey || !articleIds || articleIds.length === 0) {
      setSummaries({});
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    const ids = articleIds.join(",");
    api
      .get("/guide/feedback/summary", {
        params: { app: appKey, article_ids: ids },
      })
      .then(({ data }) => {
        if (cancelled) return;
        setSummaries(data?.summaries || {});
      })
      .catch(() => { if (!cancelled) setSummaries({}); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [appKey, articleIds, refreshKey]);

  const refresh = useCallback(() => setRefreshKey((k) => k + 1), []);
  return { summaries, loading, refresh };
}
